import React, { useRef, useState } from "react";
import "./style.css";
import Dialog from "shared/ui/Dialog/Dialog.js";
import RadioCardList from "shared/ui/RadioCardList/RadioCardList.js";
import Provider from "./Provider.js";
import BooleanButton from "../button/booleanButton.js";
import { useLocalStorage } from "../../../hooks/useLocalStorage.js";
import IntInput from "../intInput/intInput.js";
import TiersTable from "./TiersTable.js";
import PricePreview from "./PricePreview.js";
import { convertToMode, detectPriceMode, fixedPriceOf, isSimpleTiers, validateTiers, } from "./priceModes.js";
import * as styles from "./IntProviderEditor.module.css";
const modeOptions = [
    {
        value: "fixed",
        title: "Stała cena za sztukę",
        description: "Każda sztuka kosztuje tyle samo",
    },
    {
        value: "tiers",
        title: "Progi cenowe",
        description: "Np. pierwsze 3 sztuki gratis, kolejne po 5 zł",
    },
    {
        value: "advanced",
        title: "Formuła zaawansowana",
        description: "Warunki, sumy, mnożenie i inne operacje",
    },
];
/**
 * Edits the price of an item. Changes are applied after saving.
 */
export default function IntProviderEditor(props) {
    var _a, _b;
    const initialProvider = useRef(props.provider);
    const [draft, setDraft] = useState(props.provider);
    const [mode, setMode] = useState(() => detectPriceMode(props.provider));
    const [isHiddenStorage, setHiddenStorage] = useLocalStorage("int-provider-editor-hide-types", "false");
    const hasHiddenTypes = isHiddenStorage !== "false";
    const tiersError = mode === "tiers" && isSimpleTiers(draft) ?
        validateTiers(draft.tiers)
        : undefined;
    function changeMode(newMode) {
        if (newMode === mode)
            return;
        setMode(newMode);
        // Going back to the mode the price was saved in restores the saved price
        setDraft(detectPriceMode(initialProvider.current) === newMode ?
            initialProvider.current
            : convertToMode(draft, newMode));
    }
    return (React.createElement(Dialog, { maxWidth: "40rem", confirmButtonText: "Zapisz", onReject: () => props.onSetOpen(false), onSubmit: () => {
            if (tiersError)
                return;
            props.onProviderUpdate(draft);
            props.onSetOpen(false);
        } },
        React.createElement("div", { className: styles.editor },
            React.createElement("h3", { className: styles.title }, "Cena"),
            React.createElement(RadioCardList, { options: modeOptions, value: mode, onChange: changeMode }),
            React.createElement("div", { className: styles.section },
                mode === "fixed" && (React.createElement(IntInput, { label: "Cena za sztuk\u0119 (z\u0142)", state: (_a = fixedPriceOf(draft)) !== null && _a !== void 0 ? _a : 0, disableExtraSpacing: true, onChange: (value) => setDraft(value) })),
                mode === "tiers" && isSimpleTiers(draft) && (React.createElement(TiersTable, { provider: draft, onChange: setDraft, allowCategoryScope: props.allowCategoryScope })),
                mode === "advanced" && (React.createElement(React.Fragment, null,
                    React.createElement(BooleanButton, { defaultState: hasHiddenTypes, label: "Schowaj typy (poprawia przejrzysto\u015B\u0107)", onClick: (newValue) => setHiddenStorage(newValue + "") }),
                    React.createElement(Provider, { provider: draft, onProviderUpdate: setDraft, formatNames: (_b = props.formatNames) !== null && _b !== void 0 ? _b : [], defaultIsPerItemProvider: props.defaultIsPerItemProvider, hasHiddenType: hasHiddenTypes })))),
            React.createElement(PricePreview, { provider: draft }))));
}
